module.exports = __webpack_public_path__ + "8f4ff9bec281249293c6844f7477ed05.pdf";